import React from 'react';
import styled, { css } from 'styled-components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ContentTypography from 'components/ContentTypography';
import Button from '@material-ui/core/Button';

import { brand } from 'theme';

const PageHeaderGrid = styled(Grid)`
  margin-top: 5vh;
  margin-bottom: 5vh;

  ${props =>
    props.accent === 'gradient' &&
    css`
      position: relative;
      padding-left: 50px;

      > div:first-child:before {
        content: '';
        position: absolute;
        left: 0;
        width: 4px;
        background: linear-gradient(${brand.main.gradient.primary});
        height: 100%;
      }

      @media (max-width: 640px) {
        padding-left: 15px;
      }
    `};
`;

const PageHeaderBackButton = styled(Button)`
  top: -2.5vh;
  position: relative;
`;

const OverlineTypography = styled(Typography)`
  margin-bottom: 30px;
`;

const HeadingTypography = styled(ContentTypography)`
  @media (max-width: 640px) {
    font-size: calc(32px + 20 * ((100vw - 320px) / 680));
  }
`;

const SubheadingTypography = styled(ContentTypography)`
  opacity: 0.9;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.25em;
  ${props =>
    props.size === 'jumbo' &&
    css`
      font-weight: 300;
      font-size: 24px;
    `};
  @media (max-width: 640px) {
    font-size: calc(18px + 14 * ((100vw - 320px) / 680));
  }
`;

const PageHeaderText = ({
  heading,
  subheading,
  overline,
  size,
  theme,
  align,
  ...other
}) => (
  <div {...other}>
    {overline && (
      <OverlineTypography variant="overline" color="textSecondary" gutterBottom>
        {overline}
      </OverlineTypography>
    )}
    <HeadingTypography
      component="h1"
      variant={size === 'jumbo' ? 'h1' : 'h2'}
      align={align}
      dangerouslySetInnerHTML={{ __html: heading }}
    />
    <SubheadingTypography
      component="p"
      variant="h3"
      size={size}
      gutterBottom
      theme={theme}
      align={align}
      dangerouslySetInnerHTML={{ __html: subheading }}
    />
  </div>
);

export { PageHeaderGrid, PageHeaderText, PageHeaderBackButton };
